import React, { useEffect, useState } from "react";

import { calculateStatus, calculateTime, getProgressRatio, getWaveTop } from "../function/store";
import { OrdersSection } from "../styled/pickup";

import TabMenu from "../common/tabMenu";
import DetailsInfo from "./orderView/detailsInfo";
import DetailsContent from "./orderView/detailsContent";
import OrderList from "./orderView/orderList";
import OrderProgress from "../common/orderProgress";

const tabs = [
  { key: "PENDING", label: "신규 주문" },
  { key: "PICKUP", label: "완료" },
];

const OrderView = ({
  categorized,
  selectOrder,
  openModal,
  selected,
  setSelected,
  rejectOrder,
  acceptOrder,
  updateOrder,
  completedOrder,
  active,
  setActive,
  checkedOrders,
  selectCompany,
  cancelOrder,
}) => {
  const activeLabel = tabs.find((tab) => tab.key === active)?.label;

  return (
    <>
      <div className="orders">
        <TabMenu tabs={tabs} active={active} setActive={setActive} />
        <OrdersSection>
          <OrderList
            orders={categorized[active]}
            message={`${activeLabel === "완료" ? "완료 주문" : activeLabel}이 존재하지 않습니다.`}
            onClick={selectOrder}
            selected={selected}
            checkedOrders={checkedOrders}
            selectCompany={selectCompany}
          />
          <OrderList
            title={`진행중 ${categorized.READY.length}건`}
            message="진행중인 주문이 존재하지 않습니다."
            orders={categorized.READY}
            onClick={selectOrder}
            selected={selected}
            renderExtraContent={(item) => {
              return (
                <div className={`order ${selected?.id === item.id ? "selected" : ""}`}>
                  <OrderProgress item={item} selected={selected} />
                </div>
              );
            }}
          />
        </OrdersSection>
      </div>
      <div className="content pickup">
        <DetailsInfo
          selected={selected}
          openModal={openModal}
          rejectOrder={rejectOrder}
          acceptOrder={acceptOrder}
          updateOrder={updateOrder}
          setSelected={setSelected}
          completedOrder={completedOrder}
          cancelOrder={cancelOrder}
        />
        <DetailsContent selected={selected} />
      </div>
    </>
  );
};

export default OrderView;
